
import Vue from 'vue'

export default Vue.extend({
  name: 'WorkspaceCard',
  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    egList: {
      type: Array,
      default: false
    }
  }
});
